<template>
  <div class="relative">
    <BaseIcon icon="search" class="absolute left-3 top-3 text-gray-400 text-xs" />
    <input :value="value" @input="$emit('input', $event.target.value)" type="search" :placeholder="placeholder" class="bg-white border border-secondary-300 rounded text-sm text-gray-900 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 transition duration-200 pl-8 pr-3 py-2" :style="{ width: width }" />
  </div>
</template>

<script>
export default {
  name: "SoSearch",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    width: { type: String, default: "220px" },
  },
};
</script>
